export const columnData = [
  {
    id: 'vbParentTcin',
    numeric: false,
    disablePadding: true,
    label: 'Parent Tcin',
    textAlign: 'right',
  },
  {
    id: 'imageUrl',
    label: 'Image',
  },
  {
    id: 'vbName',
    numeric: false,
    disablePadding: true,
    label: 'Name',
    textAlign: 'right',
  },
  {
    id: 'kitType',
    numeric: true,
    disablePadding: true,
    label: 'Kit Type',
    textAlign: 'right',
  },
  {
    id: 'mvt',
    numeric: true,
    disablePadding: true,
    label: 'MVT',
    textAlign: 'right',
  },
  {
    id: 'vbState',
    numeric: true,
    disablePadding: true,
    label: 'Virtual Bundle State',
    textAlign: 'right',
  },
  {
    id: 'isMerchantApprovedForPublishing',
    numeric: true,
    disablePadding: true,
    label: 'Merchant Approved for Publishing',
    textAlign: 'right',
  },
  {
    id: 'launchDate',
    numeric: false,
    disablePadding: true,
    label: 'Launch Date',
    type: 'date',
  },
  {
    id: 'vbItemsCount',
    numeric: true,
    disablePadding: true,
    label: '# Items',
    textAlign: 'right',
  },
  {
    id: 'childTcinSamplesReqTotalQty',
    numeric: true,
    disablePadding: true,
    label: '# Bundle Size',
    textAlign: 'right',
  },
  {
    id: 'department',
    numeric: true,
    disablePadding: true,
    label: 'Department',
    textAlign: 'right',
  },
  {
    id: 'class',
    numeric: true,
    disablePadding: true,
    label: 'Class',
    textAlign: 'right',
  },
  {
    id: 'vendorId',
    numeric: true,
    disablePadding: true,
    label: 'Vendor Id',
    textAlign: 'right',
  },
  {
    id: 'vendorName',
    numeric: true,
    disablePadding: true,
    label: 'Vendor Name',
    textAlign: 'right',
  },
  {
    id: 'brand',
    numeric: true,
    disablePadding: true,
    label: 'Brand',
    textAlign: 'right',
  },
]

export const dataLabelsOrdered = [
  {
    id: 'pegasusId',
    numeric: false,
    disablePadding: true,
    label: 'Pegasus ID',
    align: 'center',
  },
  {
    id: 'tcin',
    numeric: true,
    disablePadding: false,
    label: 'TCIN',
    align: 'center',
  },
  {
    id: 'description',
    numeric: true,
    disablePadding: false,
    label: 'Description',
    align: 'center',
  },
  {
    id: 'imageUrl',
    numeric: false,
    disablePadding: false,
    label: 'Image',
    align: 'center',
  },

  {
    id: 'dpci',
    numeric: false,
    disablePadding: false,
    label: 'DPCI',
    textAlign: 'right',
  },
  {
    id: 'sampleStatus',
    numeric: false,
    disablePadding: true,
    label: 'Status',
  },
  { id: 'location', numeric: false, disablePadding: true, label: 'Location' },
  {
    id: 'launchDate',
    numeric: false,
    disablePadding: true,
    label: 'Launch Date',
    type: 'date',
  },
  {
    id: 'createDate',
    numeric: false,
    disablePadding: true,
    label: 'Sample Ordered Date',
    type: 'date',
  },
  {
    id: 'userId',
    numeric: false,
    disablePadding: true,
    label: 'Sample Ordered By',
  },
]
export const parentFields = [
  { xs: 1.5, label: 'Parent Name', value: 'vbName' },
  { xs: 1, label: 'Tcin', value: 'tcin' },
  {
    xs: 1.5,
    label: 'Description',
    value: 'description',
  },
  { xs: 1, label: 'Kit Type', value: 'kitType' },
  { xs: 1.5, label: 'Department', value: 'departmentName' },
  { xs: 1.5, label: 'Class', value: 'className' },
  { xs: 1, label: 'Owned Brand', value: 'isOwnedBrand' },
  { xs: 1, label: 'Brand', value: 'manufacturerBrand' },
]

export const tcinFields = [
  { xs: 0.5, label: 'Tcin', value: 'tcin' },
  { xs: 1, label: 'DPCI', value: 'dpci' },
  { xs: 1, label: 'Image', value: 'imageUrl' },
  { xs: 1.5, label: 'Description', value: 'description' },
  { xs: 1, label: 'Vendor Id', value: 'vendorId' },
  { xs: 1.5, label: 'Vendor Name', value: 'vendorName' },
  { xs: 1, label: 'Department', value: 'departmentName' },
  { xs: 1, label: 'Class', value: 'className' },
  { xs: 1, label: 'Brand', value: 'manufacturerBrand' },
  { xs: 0.5, label: 'Size', value: 'size' },
  { xs: 0.5, label: '#Samples', value: 'samples.length' },
  { xs: 1, label: '#Component Quantity', value: 'quantity' },
]

export const clickableColumn = ['imageUrl', 'vbName']

export const tabList = [
  {
    label: 'Ordered Tcins',
    value: 'Ordered Tcins',
  },
  {
    label: 'Remaining Tcins',
    value: 'Remaining Tcins',
  },
]

export const groupStates = [
  'ALL',
  'INITIATED',
  'READY FOR ORDER',
  'READY FOR LAUNCH',
  'DELETED',
]

export const mvtOptions = ['all', 'OB', 'OB+NB','NB-Multi', 'NB']
export const dataLabelsTabRemaining = [
  {
    id: 'tcin',
    numeric: true,
    disablePadding: false,
    label: 'TCIN',
    align: 'center',
  },
  {
    id: 'imageUrl',
    numeric: false,
    disablePadding: true,
    label: 'Image',
    align: 'center',
  },
  {
    id: 'dpci',
    numeric: false,
    disablePadding: false,
    label: 'DPCI',
    textAlign: 'right',
  },
  {
    id: 'description',
    numeric: false,
    disablePadding: true,
    label: 'Item Description',
  },
  { id: 'size', numeric: false, disablePadding: true, label: 'Size' },
  {
    id: 'departmentName',
    numeric: false,
    disablePadding: false,
    label: 'Department',
  },
  { id: 'className', numeric: false, disablePadding: false, label: 'Class' },
  {
    id: 'launchDate',
    numeric: false,
    disablePadding: true,
    label: 'Launch Date',
    type: 'date',
  },
  {
    id: 'vendorId',
    numeric: true,
    disablePadding: false,
    label: 'Vendor ID',
  },
  {
    id: 'vendorName',
    numeric: false,
    disablePadding: false,
    label: 'Vendor Name',
  },
]
